import createVueApp from '@/common/createApp'

Styxie.Initializers.Pricing = {
  show: async(props) => {
    const { default: Pricing } = await import('@/vue_widgets/pricing/index.vue')
    createVueApp(Pricing, { props })
  }
}
